import React, { useState, useEffect } from 'react';
import { alpha } from "@mui/material/styles";
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@mui/material';
import { canMonitor, isAnalista } from "../commons/utils";
import ListTramites from './ListTramites';
import { IconButton } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Menu } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import GestionesInternasModal from '../commons/GestionesInternasModal';
import GestionesExternasModal from '../commons/GestionesExternasModal';

import { postGestionExterna, ginterna } from '../../service/service.supersalud';


const useStyles = makeStyles((theme) => ({


    toolbarsearch: {

        width: '90%',
        margin: '0 auto',
        maxWidth: '1100px',
        marginTop: 24
    },
    textHelpSearch: {

        textAlign: "center",
        paddingLeft: 10,
        fontSize: 14,
        color: "#040404"

    },

    backSuper: {
        background: "url(https://rnpi.superdesalud.gob.cl/app/images/3.png) no-repeat center center fixed",
        backgroundSize: "cover"
    },



    /* '@media screen and (min-width: 700px)': {
        toolbarsearch: {
            display: 'block',
        },
        
      }, */
    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    title: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block"
        },

    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,

        "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.25)
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto"
        },
        backgroundColor: "#0064AC"
    },

    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    inputRoot: {
        color: "inherit"
    },

    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "20ch"
        }
    },
    sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex"
        }
    },
    sectionMobile: {
        display: "flex",
        marginTop: "10px",
        [theme.breakpoints.up("md")]: {
            display: "none"
        }
    },
    //   inputSearch: {
    //     backgroundColor: "#d5d5d5 !important",
    // }
    root2: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: "100%",
        backgroundColor: '#fafafa'

    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 15,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

const ListTramitesIndex = props => {

    const { user, userLogOut, wildcard, rut, userLoggedIn, type } = props;
    const history = useHistory();
    const [selectedValue, setSelectedValue] = useState('rut');
    const [showGestionInterna, setShowGestionInterna] = useState(false)
    const [showGestionExterna, setShowGestionExterna] = useState(false)
    const [showComprobante, setShowComprobante] = useState(true)
    const [folioExterno, setFolioExterno] = useState('')
    const [folioInterno, setFolioInterno] = useState("")
    const [loading, setLoading] = useState(false)

    /* menu  */

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    /* ++++ */

    const classes = useStyles();
    /*    const { user, userLoggedIn } = props; */

    // const [search, setSearch] = useState({ wildcard: undefined, rut: (user || {}).rut });
    const [search, setSearch] = useState('');
    const [timeoutId, setIdTimeout] = useState({ wildcard: undefined });
    const { innerWidth: width/*, innerHeight: height*/ } = window;
    const [searchNow, setSearchNow] = useState(false)
    const [reload, setReload] = useState(false)

    //const listTramitesRender = useMemo(() => <ListTramites {...{ ...props, ...search, userLoggedIn }} />, [props, search.rut, search.wildcard]) 
    /* const listTramitesRender = useMemo(() => <ListTramites {...{ ...props, userLoggedIn }} rut={user.rut} wildcard={search} type={selectedValue} />) */

    useEffect(() => {
        if (!canMonitor(user)) {
            history.push('/listreclamo')
        }
    })

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseInternas = () => {
        setShowGestionInterna(false)
    }

    const handleCloseExternas = () => {
        setShowGestionExterna(false)
        setFolioExterno('')
        setFolioInterno('')
        setShowComprobante(true)
        setLoading(false)
    }

    const handleSubmitInternas = (data) => {
        inyectarGestionInterna(data)
    }

    const handleSubmitExternas = (data) => {
        inyectarGestionExterna(data)

    }

    const inyectarGestionExterna = async (tramite) => {

        const resp = await postGestionExterna(user, userLogOut, userLoggedIn)(JSON.stringify({ usuario_solicitante: tramite.usuario_solicitante, prioridad: tramite.prioridad, solicitud: tramite.solicitud, dias: tramite.dias, files: tramite.files }))
        if (resp.status === 201) {
            const results = await resp.json()
            setShowComprobante(!showComprobante)
            setFolioExterno(results)
            setReload(!reload)
        }

        setLoading(false)
    }

    const inyectarGestionInterna = async (tramite) => {
        let respuesta = undefined
        respuesta = await ginterna(user, userLogOut, userLoggedIn)(JSON.stringify({
            ...(tramite),
        }));

        const resp_status = (respuesta || {}).status;
        //console.log("resp_status",resp_status)
        if (resp_status === 200 || resp_status === 201) {
            const results = await respuesta.json()
            //console.log("respuesta",results)   
            setFolioInterno(results)
            setReload(!reload)
        }
        setLoading(false)
    }


    return (

        <div className={classes.backSuper}>
            <div className={classes.toolbarsearch}>


                {!isAnalista((user || {}).auth) ?
                    null
                    :
                    /*  width > 500 ? */

                    <Box >
                        {canMonitor(user) ?
                            <Grid container>
                                <Grid container item xs={12}>
                                    <Grid container item xs={6}>
                                        <Grid style={{ cursor: 'pointer', marginRight: 2 }} onClick={() => { history.push('/listreclamo') }}>
                                            <p>Seguimiento</p>
                                        </Grid>
                                        <Grid>
                                            <p>/</p>
                                        </Grid>
                                        <Grid style={{ cursor: 'pointer', marginLeft: 2, marginRight: 2 }} onClick={() => { history.push('/monitoreo') }}>
                                            <p >Monitoreados</p>
                                        </Grid>
                                        <Grid>
                                            <p>/</p>
                                        </Grid>
                                        <Grid style={{ cursor: 'pointer', marginLeft: 2, marginRight: 2 }} onClick={() => { history.push('/movimientos') }}>
                                            <p>Movimientos</p>
                                        </Grid>
                                        <Grid>
                                            <p>/</p>
                                        </Grid>
                                        <Grid style={{ cursor: 'pointer', marginLeft: 2 }}  >
                                            <p style={{ fontWeight: 'bold', color: 'blue', textDecoration: 'underline' }}>Histórico</p>
                                        </Grid>
                                    </Grid>
                                    <Grid container justify="flex-end" item xs={6}>
                                    </Grid>
                                </Grid>
                            </Grid>
                            :
                            null
                        }
                        <GestionesInternasModal
                            closeModal={handleCloseInternas}
                            submitModal={handleSubmitInternas}
                            openDialog={showGestionInterna}
                            folioInterno={folioInterno}
                            user={user}
                            userLogOut={userLogOut}
                            userLoggedIn={userLoggedIn}
                        />
                        <GestionesExternasModal
                            closeModal={handleCloseExternas}
                            submitModal={handleSubmitExternas}
                            openDialog={showGestionExterna}
                            showComprobante={showComprobante}
                            folioExterno={folioExterno}
                            loading={loading}
                            setLoading={setLoading}
                        />
                        <ListTramites {...{ ...props, userLoggedIn }} rut={user.rut} wildcard={search} type={selectedValue} searchNow={searchNow} reload={reload} />
                    </Box>
                }

            </div>
        </div>
    );
}

export default ListTramitesIndex;
